import React, { useLayoutEffect, useRef, useState } from 'react';

// Renders a game board at its desktop size and scales it down evenly when the
// screen is narrower, so phones see the same layout as desktop, just smaller.
const FitToWidth = ({ children, className = '' }) => {
  const outer = useRef(null);
  const inner = useRef(null);
  const [box, setBox] = useState({ scale: 1, height: undefined, left: 0 });

  useLayoutEffect(() => {
    const fit = () => {
      if (!outer.current || !inner.current) return;
      const avail = outer.current.clientWidth;
      const width = inner.current.offsetWidth;
      const scale = width > avail ? avail / width : 1;
      setBox({ scale, height: inner.current.offsetHeight * scale, left: Math.max(0, (avail - width * scale) / 2) });
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(outer.current);
    ro.observe(inner.current);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={outer} className={`relative w-full ${className}`} style={{ height: box.height }}>
      <div ref={inner} className="absolute top-0 w-max" style={{ left: box.left, transform: `scale(${box.scale})`, transformOrigin: 'top left' }}>
        {children}
      </div>
    </div>
  );
};

export default FitToWidth;

// Scale factor that fits a board of a known size (in px) into the window,
// leaving room for the navbar and some margin. Never scales up.
export const useFitScale = (width, height, { marginX = 24, marginY = 140 } = {}) => {
  const calc = () => Math.min(1, (window.innerWidth - marginX) / width, (window.innerHeight - marginY) / height);
  const [scale, setScale] = useState(calc);
  useLayoutEffect(() => {
    const onResize = () => setScale(calc());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  });
  return scale;
};
